<template>
  <svg
    class="icon fill-current"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M19.5 2C20.8789 2 22 3.12109 22 4.5V15.75C22 17.1289 20.8789 18.25 19.5 18.25H13.875L8.99609 21.9102C8.6875 22.1367 8.25 21.9141 8.25 21.5312V18.25H4.5C3.12109 18.25 2 17.1289 2 15.75V4.5C2 3.12109 3.12109 2 4.5 2H19.5ZM17 7.23926C17 7.02668 16.7472 6.92003 16.5996 7.07031L15.5059 8.18359C15.4841 8.20574 15.4669 8.23278 15.4551 8.26172C15.4434 8.29051 15.4375 8.32139 15.4375 8.35254V10.0225H9.71191L10.8926 8.90234C11.0872 8.71828 11.0921 8.40612 10.9043 8.21484L10.4736 7.77637C10.2912 7.59067 9.99577 7.58961 9.8125 7.77441L7.13867 10.4795C6.95384 10.6662 6.95382 10.9705 7.13867 11.1572L9.8125 13.8613C9.9957 14.0463 10.2911 14.046 10.4736 13.8604L10.9043 13.4219C11.0921 13.2306 11.0871 12.9185 10.8926 12.7344L9.71191 11.6133H16.5312C16.79 11.6132 16.9998 11.4001 17 11.1367V7.23926Z"
    />
  </svg>
</template>

<script>
export default {
  name: 'MessageReplyIcon'
}
</script>
